import Link from "next/link";
import { ChevronRight } from "lucide-react";
import { Fragment } from "react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
  /** Defaults to the last crumb. Pass false when the page is a child of the last crumb. */
  current?: boolean;
}

/** Real links only — no placeholder crumbs for routes that don't exist. */
export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Breadcrumb" className="ui-breadcrumb">
      {items.map((item, index) => {
        const current = item.current ?? index === items.length - 1;
        return (
          <Fragment key={`${index}:${item.href ?? item.label}`}>
            {index > 0 ? (
              <ChevronRight size={14} className="ui-breadcrumb-sep" aria-hidden="true" />
            ) : null}
            {item.href && !current ? (
              <Link href={item.href}>{item.label}</Link>
            ) : (
              <span aria-current={current ? "page" : undefined}>{item.label}</span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
